<template>
  <div class="flex">
    <TabGroup>
      <div class="flex flex-col w-full">
        <TabList class="flex gap-2 text-dimmed text-xl p-2 my-2 pl-4 lg:pl-0">
          <ArrowTrendingUpIcon class="h-6" />
          <Tab v-slot="{ selected }" as="template">
            <button class="ring-none focus:outline-none" :class="{ 'text-quicklist': selected }">
              {{ $t("Popular") }}
            </button>
          </Tab>
          <span> / </span>
          <Tab v-slot="{ selected }" as="template">
            <button class="ring-none focus:outline-none" :class="{ 'text-quicklist': selected }">
              {{ $t("Upcoming") }}
            </button>
          </Tab>
          <span> / </span>
          <Tab v-slot="{ selected }" as="template">
            <button class="ring-none focus:outline-none" :class="{ 'text-quicklist': selected }">
              {{ $t("New") }}
            </button>
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <QuickListPopular />
          </TabPanel>
          <TabPanel>
            <QuickListUpcoming />
          </TabPanel>
          <TabPanel>
            <QuickListNewEvents />
          </TabPanel>
        </TabPanels>
      </div>
    </TabGroup>
  </div>
</template>

<script setup>
import { ArrowTrendingUpIcon } from "@heroicons/vue/24/outline";
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from "@headlessui/vue";

import { QuickListPopular, QuickListUpcoming, QuickListNewEvents } from ".";
</script>
